enum RESULTS_VIEW {
  DATAGRID = "DATAGRID",
  TILE = "TILE",
}
export default RESULTS_VIEW;
